/* unplugin-vue-components disabled */import script from "./multiple-input.vue?vue&type=script&setup=true&lang=js"
export * from "./multiple-input.vue?vue&type=script&setup=true&lang=js"

import "./multiple-input.vue?vue&type=style&index=0&id=1e653266&lang=scss"

const __exports__ = script;

export default __exports__